import db from 'utils/localstorage'

function getBooleanValue (value, defaultValue) {
  if (Object.is(value, null) || value === undefined) {
    return defaultValue
  }
  if (JSON.stringify(value) !== '{}') {
    return value
  }
  return false
}

export default {
  namespaced: true,
  state: {
    asyncRouter: db.get('USER_ROUTER', []),
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get('THEME', 'dark'),
    layout: db.get('LAYOUT', 'side'),
    systemName: '电竞管理后台',
    copyright: `${new Date().getFullYear()} <a href="/" target="_blank">电竞管理后台</a>`,
    multipage: getBooleanValue(db.get('MULTIPAGE'), true),
    fixSiderbar: getBooleanValue(db.get('FIX_SIDERBAR'), true),
    fixHeader: getBooleanValue(db.get('FIX_HEADER'), true),
    color: db.get('COLOR', 'rgb(24, 144, 255)')
  },
  mutations: {
    setRouter (state, asyncRouter) {
      db.save('USER_ROUTER', asyncRouter)
      state.asyncRouter = asyncRouter
    },
    setTheme (state, theme) {
      db.save('THEME', theme)
      state.theme = theme
    },
    setLayout (state, layout) {
      db.save('LAYOUT', layout)
      state.layout = layout
    },
    setMultipage (state, multipage) {
      db.save('MULTIPAGE', multipage)
      state.multipage = multipage
    },
    setSidebar (state, type) {
      state.sidebar.opened = type
    },
    setDevice (state, isMobile) {
      state.isMobile = isMobile
    },
    fixSiderbar (state, flag) {
      db.save('FIX_SIDERBAR', flag)
      state.fixSiderbar = flag
    },
    fixHeader (state, flag) {
      db.save('FIX_HEADER', flag)
      state.fixHeader = flag
    },
    setSettingBar (state, flag) {
      state.settingBar.opened = flag
    },
    setColor (state, color) {
      db.save('COLOR', color)
      state.color = color
    }
  }
}
